import { useMemo } from 'react';
import {
  CurrencyFormatResult,
  formatCurrency,
  useLocale,
} from '@unisporkal/localization';
import useOnLoad from './queries/useOnLoad';
import useSelectedIndex from './stateful/useSelectedIndex';

const findUltraPackData = (config: any) => {
  const data = config.options?.find(
    (option: any) => option.type === 'standardlicense'
  );
  const [pack] =
    data?.sizes?.find((size: any) => size.license === 'ultrapack')
      ?.imagePackSavings || [];
  return pack;
};

type HookOptions = {
  priceDecimalDigits?: number;
};

export const useUltrapackLicense = ({
  priceDecimalDigits,
}: HookOptions): {
  ultraPackData: any; // todo USE defined type
  isUltraPackLicense: boolean;
  price: number;
  formattedTotalPrice: CurrencyFormatResult;
  currencyCode: string;
} => {
  const { response } = useOnLoad();
  const { selectedSize } = useSelectedIndex();
  const locale = useLocale();

  const isUltraPackLicense = selectedSize?.license === 'ultrapack';

  const ultraPackData = useMemo(
    () => findUltraPackData(response.config),
    [response.config]
  );

  const priceFormattingOptions =
    typeof priceDecimalDigits === 'number'
      ? {
          separateGeoTaxFromPrice: true,
          minimumFractionDigits: priceDecimalDigits,
        }
      : { separateGeoTaxFromPrice: true };

  const formattedTotalPrice = useMemo(
    () =>
      formatCurrency(
        ultraPackData?.packPrice || 0,
        locale,
        selectedSize?.currencyCode,
        priceFormattingOptions
      ),
    [locale, ultraPackData, priceDecimalDigits]
  );

  return {
    ultraPackData,
    isUltraPackLicense,
    price: 0,
    formattedTotalPrice,
    currencyCode: selectedSize?.currencyCode,
  };
};
